var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAntdesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.83 198.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "antdesign") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M90.93,3.54,3.52,90.87a12,12,0,0,0,0,17l87.41,87.33a12,12,0,0,0,17,0l36.65-36.61a10.77,10.77,0,0,0-15.24-15.23L101.55,171.1a2.86,2.86,0,0,1-4.12,0l-69.8-69.75a2.85,2.85,0,0,1,0-4.11L97.43,27.5a2.86,2.86,0,0,1,4.12,0l27.78,27.76A10.77,10.77,0,0,0,144.57,40L107.92,3.42A12.11,12.11,0,0,0,90.93,3.54Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.93,3.54,3.52,90.87a12,12,0,0,0,0,17l87.41,87.33a12,12,0,0,0,17,0l36.65-36.61a10.77,10.77,0,0,0-15.24-15.23L101.55,171.1a2.86,2.86,0,0,1-4.12,0l-69.8-69.75a2.85,2.85,0,0,1,0-4.11L97.43,27.5c2.91-2.51,7.67-7.6,14.64-8.79q7.79-1.32,17,5.84-6.17-6.16-21.16-21.13A12.11,12.11,0,0,0,90.93,3.54Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,135.22a10.79,10.79,0,0,0,15.24,0l27-27a12,12,0,0,0,0-17L168,64.08a10.78,10.78,0,0,0-15.26,15.24l18.42,18.4a2.85,2.85,0,0,1,0,4.11L153,120A10.76,10.76,0,0,0,153,135.22Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.86,
    cy: 99.8,
    rx: 23.6,
    ry: 23.58,
    style: {
      fill: "#173c57"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntdesign);
export default __webpack_public_path__ + "static/media/antdesign.789cb571d77109e123d7bf6e32d81c0b.svg";
export { ForwardRef as ReactComponent };